import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/order/components/OrderInteractive.tsx");
